import {gql} from '@apollo/client';
import {getDomainGraphqlError, useMutation$} from "../../graphqlsupport";
import {useCallback} from "react";
import {showToast} from 'common/component/NotificationToaster';
import {YesNoOption} from "../client/domain";

export const CONFIRM_TREATMENT_HOLD_END = gql`
    mutation confirmTreatmentHoldEnd(
        $providerEventGuid: UUID!
        $providerConfirmedResumeServices: YesNoOption!
    ) {
        confirmTreatmentHoldEnd(
            providerEventGuid: $providerEventGuid
            providerConfirmedResumeServices: $providerConfirmedResumeServices
        )
    }
`;

type ConfirmTreatmentHoldEndInput = {
    providerEventGuid: string;
    providerConfirmedResumeServices: YesNoOption;
};

export const useConfirmTreatmentHoldEnd = (successCallback: () => void) => {
    const {isRunning$, execute} = useMutation$<ConfirmTreatmentHoldEndInput, void>(CONFIRM_TREATMENT_HOLD_END);

    const confirmTreatmentHoldEnd = useCallback(async (
        providerEventGuid: string,
        providerConfirmedResumeServices: YesNoOption,
    ) => {
        try {
            const {data: result} = await execute({
                variables: {
                    providerEventGuid,
                    providerConfirmedResumeServices,
                },
            });
            if (result !== undefined) {
                successCallback();
                showToast.success("Treatment hold confirmation submitted");
            }
        } catch (e: any) {
            showToast.error(getDomainGraphqlError(e) ?? `Unable to submit confirmation: ${e.message || e[0]?.message}`);
        }
    }, [execute, successCallback]);

    return {
        isRunning$,
        execute: confirmTreatmentHoldEnd,
    };
};
